import React from 'react'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import { getClassNames } from '@helpers/productWidgetHelper'
import Image from 'next/image'
import { BULLET_ICON_SRC } from '@constants/bullet'
import { extractIdFromContent } from '@utils/extractId'
import styles from './bulletCard.module.scss'

const BulletCard = ({ data }) => {
  const { isSemPage } = data
  const {
    sectionHeading,
    bulletPoints,
    cardHeading,
    cardSubHeading,
    cardImage,
    isCardPurple,
    numberedBullets,
    headerTabName,
  } = data?.data?.attributes

  const containerClassName = getClassNames([styles.rootContainer], {
    [styles.seoStyles]: !isSemPage,
  })

  const cardContainerClassName = getClassNames([styles.cardContainer], {
    [styles.purpleBg]: isCardPurple,
  })

  return (
    <ErrorBoundary data={data}>
      <div className={containerClassName} id={extractIdFromContent(sectionHeading, headerTabName)}>
        <div className={styles.sectionHeading} dangerouslySetInnerHTML={{ __html: sectionHeading }} />
        <div className={cardContainerClassName}>
          {cardImage?.data?.attributes?.url && (
            <Image
              src={cardImage?.data?.attributes?.url}
              alt="Card Image"
              className={styles.cardImageStyles}
              width={500}
              height={288}
            />
          )}
          <div className={styles.bulletPoints}>
            {(cardHeading || cardSubHeading) && (
              <div className={styles.cardTopSection}>
                {cardHeading && <span className={styles.cardHeading}>{cardHeading}</span>}
                {cardSubHeading && <span className={styles.cardSubHeading}>{cardSubHeading}</span>}
              </div>
            )}
            <div className={`${styles.cardBottomSection} ${isCardPurple ? styles.moreSpacing : ''}`}>
              {bulletPoints?.map((bullet, index) => (
                <div key={bullet?.bulletText} className={styles.bullet}>
                  {numberedBullets ? (
                    <div className={styles.bulletNumber}>{index + 1}</div>
                  ) : (
                    <Image
                      src={BULLET_ICON_SRC}
                      alt="Bullet logo"
                      className={styles.bulletLogo}
                      width={12}
                      height={12}
                    />
                  )}
                  <span className={styles.bulletText}>{bullet?.bulletText}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default BulletCard
